<template>
  <div>
    <div class="title">生物计量专业委员会 2019年年会与研讨会顺利召开</div>
    <div class="sub-title">
      <span>发布时间：2019-11-23 15:43:22</span>
      <span>信息来源：</span>
    </div>
    <div class="content">
      <!-- VR -->
      <div class="VR-box">
        <img src="../../../assets/images/shisanwu/矩形@2x(5).png" alt="">
        <img class="icon-360" src="../../../assets/images/360@2x.png" alt="">
      </div>
      <p>本文提出了考虑材料强化的结构安定和极限分析的应力补偿法，并将其应用于管道弯头的结构完整性分析。为了验证所提出方法的有效性，对一个圆筒进行了数值试验，其计算结果与文献中结果吻合较好。然后，将提出的方法应用于承受恒定内压和循环弯矩作用的有界限随动强化管道弯头的安定分析和极限分析。考虑了不同的载荷组合，建立了管道弯头的安定极限和塑性极限载荷边界曲线。分析了材料强化、弯头角度和载荷条件对安定极限和塑性极限载荷边界曲线的影响。本文所得的结果为实际管道弯头的结构设计和完整性评估提供了有用的信息。</p>
      <p>研制了光纤型THz-TDS系统，如图1图2所示。通过光纤色散管理实现了飞秒脉冲宽度的控制，使得到达太赫兹光电导天线的飞秒脉冲宽度保持在50 fs左右，从而消除了因飞秒脉冲展宽导致的太赫兹时域脉冲展宽。通过对飞秒激光偏振态的精确控制，使泵浦激光和探测激光偏振方向与保偏光纤的快轴或慢轴保持平行，从而消除了太赫兹时域脉冲的分裂现象，获得了信噪比优于12000的单脉冲太赫兹时域波形。采用变角度光路结构设计，实现了太赫兹透射光谱测量与反射光谱测量的便捷切换，以及材料变角度太赫兹反射光谱的测量，为进一步降低太赫兹功率测量不确定度奠定了基础。</p>
      <p>研制了光纤型THz-TDS系统，如图1图2所示。通过光纤色散管理实现了飞秒脉冲宽度的控制，使得到达太赫兹光电导天线的飞秒脉冲宽度保持在50 fs左右，从而消除了因飞秒脉冲展宽导致的太赫兹时域脉冲展宽。通过对飞秒激光偏振态的精确控制，使泵浦激光和探测激光偏振方向与保偏光纤的快轴或慢轴保持平行，从而消除了太赫兹时域脉冲的分裂现象，获得了信噪比优于12000的单脉冲太赫兹时域波形。采用变角度光路结构设计，实现了太赫兹透射光谱测量与反射光谱测量的便捷切换，以及材料变角度太赫兹反射光谱的测量，为进一步降低太赫兹功率测量不确定度奠定了基础。</p>
    </div>
  </div>
</template>

<script>
export default {
}
</script>

<style lang="less" scoped>
.title {
  margin-bottom: 6px;
  font-size: 36px;
  font-weight: 500;
  line-height: 50px;
  color: rgba(0, 0, 0, 0.85);
  text-align: center;
}
.sub-title {
  margin-bottom: 24px;
  padding-bottom: 30px;
  font-size: 12px;
  line-height: 17px;
  color: rgba(0, 0, 0, 0.65);
  text-align: center;
  border-bottom: 1px solid rgba(0, 0, 0, 0.1);
  span:first-child {
    margin-right: 15px;
  }
}
.content {
  padding-bottom: 34px;
  p {
    margin-bottom: 24px;
    font-size: 14px;
    font-family: PingFangSC-Regular, PingFang SC;
    font-weight: 400;
    color: rgba(0, 0, 0, 0.85);
    line-height: 28px;
    letter-spacing: 1px;
    text-indent: 2em;
  }
  .VR-box {
    position: relative;
    margin: 0 auto;
    margin-bottom: 24px;
    width: 352px;
    height: 270px;
    img {
      width: 100%;
      height: 100%;
    }
    .icon-360 {
      position: absolute;
      top: 10px;
      right: 10px;
      z-index: 1;
      width: 32px;
      height: 32px;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/layout/article/components/VRContent.vue